import { Request } from 'api';
import { AxiosResponse } from 'axios';
import {
    ValdIntegrationsResponse,
    ValdVerifyCredentialsResponse,
    CreateValdIntegrationRequest,
    ValdIntegration,
    ValdImportRunsResponse,
    IntegrationImportStatus,
    TriggerImportRequest,
    TriggerImportResponse,
    ImportEntityType,
    ImportStatus,
} from './integrations.types';

export const getValdIntegrations = (): Promise<AxiosResponse<ValdIntegrationsResponse>> => {
    return Request.get('/admin/vald/forcedecks/integrations');
};

export const verifyValdCredentials = (): Promise<AxiosResponse<ValdVerifyCredentialsResponse>> => {
    return Request.get('/admin/vald/forcedecks/verify-credentials');
};

export const createValdIntegration = (
    data: CreateValdIntegrationRequest,
): Promise<AxiosResponse<ValdIntegration>> => {
    return Request.post('/admin/vald/forcedecks/integrations', data);
};

export const deleteValdIntegration = (uuid: string): Promise<AxiosResponse<any>> => {
    return Request.delete(`/admin/vald/forcedecks/integrations/${uuid}`);
};

export interface GetImportRunsParams {
    integration_id?: string;
    entity_type?: ImportEntityType;
    status?: ImportStatus;
    limit?: number;
}

export const getValdImportRuns = (
    params?: GetImportRunsParams,
): Promise<AxiosResponse<ValdImportRunsResponse>> => {
    return Request.get('/admin/vald/forcedecks/imports', { params });
};

export const getIntegrationImportStatus = (
    integrationUuid: string,
): Promise<AxiosResponse<IntegrationImportStatus>> => {
    return Request.get(`/admin/vald/forcedecks/imports/${integrationUuid}/status`);
};

export const triggerValdImport = (
    integrationUuid: string,
    data: TriggerImportRequest,
): Promise<AxiosResponse<TriggerImportResponse>> => {
    return Request.post(`/admin/vald/forcedecks/imports/${integrationUuid}/trigger`, data);
};
